import axiosClient from './axiosClient'
import {
  IMegaMenuListResponse,
  IUpdateMegaMenuValue,
} from 'src/interfaces/mega-menu'

const MEGA_MENU_ENDPOINTS = {
  GET_LIST: '/meta-menus',
  UPDATE: (id: number) => `/meta-menus/${id}`,
}

export const megaMenuAPI = {
  getListMegaMenu: async (): Promise<IMegaMenuListResponse> => {
    const response = await axiosClient.get(MEGA_MENU_ENDPOINTS.GET_LIST)
    return response.data
  },

  updateMegaMenu: async (id: number, data: IUpdateMegaMenuValue) => {
    const response = await axiosClient.put(MEGA_MENU_ENDPOINTS.UPDATE(id), data)
    return response.data
  },
}
